module.exports = __webpack_public_path__ + "static/media/barrel1.62f07bb9.jpg";